/* 지역관리 지역 추가/수정 */
$(".localEditBtn").on("click", function(e){
    e.preventDefault();

    $('#local_input_form .bootstrap-select').hide();
    $("#localDeleteBtn").hide();

    var id = $(this).data('id');

    if( $(this).data('depth') == '2' ){
        $('#local_input_form .bootstrap-select').show();
        $("#local_input_code").show();
    }

    $("#local_input_modal_title").html($(this).data('title'));
    $("#local_input_depth").val($(this).data('depth'));
    $("#local_input_parent").val($(this).data('parent'));
    $("#local_input_name").val($(this).data('name'));
    $("#local_input_name_en").val($(this).data('nameen'));
    $("#local_input_code").val($(this).data('code'));

    if( id ){
        $("#localDeleteBtn").show();
        $("#localDeleteBtn").attr('data-id',id);
        $("#local_input_form > input[name=_method]").val("PUT");
        $("#local_input_form").attr('action',"locals" + "/"+id );
    }
});

/* 지역관리 지역 삭제 */
$("#localDeleteBtn").on("click", function(e){
    e.preventDefault();

    if( confirm("해당 지역을 정말 삭제 합니까?") ) {
        if( confirm("하위 지역 이 있는 경우 하위 지역 까지 삭제 되게 됩니다.\n그래도 삭제 합니까?") ) {
            var id = $(this).data('id');
            if (id) {
                $("#local_input_form > input[name=_method]").val("DELETE");
                $("#local_input_form").attr('action', "locals" + "/" + id);
                $('#local_input_form').submit();
            }
        }
    }
});

/* 국가정보 자동입력 셀렉터 */
$("#local_input_country").on('change', function(e){
    e.preventDefault();

    $("#local_input_name").val($(this).find(':selected').data('kname'));
    $("#local_input_name_en").val($(this).find(':selected').data('ename'));
    $("#local_input_code").val($(this).find(':selected').data('code'));

});




/* 국가 정보 입력 */
$(".countryEditBtn").on("click", function(e){

    /* 초기화 */
    e.preventDefault();
    $("#country_input_form").each(function(){
        this.reset();
    });

    $("#printImages").html("");

    $('#country_input_languages').selectpicker('val', []);
    $('#country_input_currency').selectpicker('val', []);
    $('#country_input_parallaxChk').selectpicker('val', []);
    $('#country_input_voltage').selectpicker('val', []);
    $('#country_input_hertz').selectpicker('val', []);
    $('#country_input_prise_electrique').selectpicker('val', []);
    $('#country_input_form .selectpicker').selectpicker('reflash');

    const json = $(this).data('json');
    const option = $(this).data('option');

    $("#country_input_modal_title").html($(this).data('title'));
    $("#country_input_form input[name=country]").val(json.code);

    $('#country_input_languages').selectpicker('val', eval(option.languages));
    $('#country_input_currency').selectpicker('val', eval(option.currency));
    $('#country_input_parallaxChk').selectpicker('val', eval(option.parallaxChk));
    $('#country_input_voltage').selectpicker('val', eval(option.voltage));
    $('#country_input_hertz').selectpicker('val', eval(option.hertz));
    $('#country_input_prise_electrique').selectpicker('val', eval(option.prise_electrique));
    $("#country_input_form input[name=parallax]").val(option.parallax);
    $("#country_input_form textarea[name=serviceinfo]").val(option.serviceinfo);
    $("#country_input_form textarea[name=immigration]").val(option.immigration);

    // 이미지 리스트
    if( isset(option.images) ) {
        var images = JSON.parse(option.images);
        var printImageSource = $("#editImages").val();
        var printImagePrint = "";
        for (var image_i in images) {
            var printImagesTmp = printImageSource;
            printImagesTmp = printImagesTmp.replace(/{--imgid--}/gi, image_i);
            printImagesTmp = printImagesTmp.replace(/{--image--}/gi, "/storage/" + images[image_i]);
            printImagePrint += printImagesTmp;
        }
        $("#printImages").html(printImagePrint);
    }
    $("#printImages").sortable({
        placeholder: 'sortable_placeholder',
        update: function () {
            var sorted = $( "#printImages" ).sortable( "toArray", {attribute: 'value'} );
            $('#sortedImages').val(sorted);
        }
    });

    // 공항리스트
    const airports = $(this).data('airports');
    if( isset(airports) ){
        var airportsHTML = '';
        for ( var airport in airports ){
            airportsHTML += '<span class="badge badge-secondary mr-1">' + airports[airport].code + ' : ' + airports[airport].k_name + '</span>'
        }

        $('#country_airport').html(airportsHTML);
    }

    $('#country_input_form .selectpicker').selectpicker('reflash');
});




/* 도시 정보 입력 */
$(".cityEditBtn").on("click", function(e){

    /* 초기화 */
    e.preventDefault();
    $("#city_input_form").each(function(){
        this.reset();
    });

    $("#printCityImages").html("");

    var datas =  $(this).data();

    $("#city_input_modal_title").html( datas.title );
    $("#city_input_form input[name=city]").val(datas.city);
    $("#city_input_form textarea[name=info]").val(datas.option.info);

    // 이미지 리스트
    if( isset(datas.option.images) ) {
        var images = JSON.parse(datas.option.images);
        var printImageSource = $("#editImages").val();
        var printImagePrint = "";
        for (var image_i in images) {
            var printImagesTmp = printImageSource;
            printImagesTmp = printImagesTmp.replace(/{--imgid--}/gi, image_i);
            printImagesTmp = printImagesTmp.replace(/{--image--}/gi, "/storage/" + images[image_i]);
            printImagePrint += printImagesTmp;
        }
        $("#printCityImages").html(printImagePrint);
    }
    $("#printCityImages").sortable({
        placeholder: 'sortable_placeholder',
        update: function () {
            var sorted = $( "#printCityImages" ).sortable( "toArray", {attribute: 'value'} );
            $('#sortedCityImages').val(sorted);
        }
    });


    // 공항리스트
    const airports = $(this).data('airports');
    if( isset(airports) ){
        var airportsHTML = '';
        for ( var airport in airports ){
            airportsHTML += '<span class="badge badge-secondary mr-1">' + airports[airport].code + ' : ' + airports[airport].k_name + '</span>'
        }

        $('#city_airport').html(airportsHTML);
    }

    // 키워드 세팅
    $("#city_tag").tagsinput('removeAll');
    var tags = datas.option.tag;
    if( tags ) {
        var tagArray = tags.split(',');
        for (var tag_i in tagArray) {
            $("#city_tag").tagsinput('add', tagArray[tag_i]);
        }
    }
});



/* 탭 컨트롤 */
$('.nav-tabs a:first').tab('show');
$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    localStorage.setItem('selectedTab', $(e.target).attr('id'));
});
var selectedTab = localStorage.getItem('selectedTab');
if (selectedTab) {
    $('#' + selectedTab).tab('show');
}

